import {useIcp} from './useIcp.mjs'

export const Icp = props => {
    const {data: icp} = useIcp()

    if (! icp) {
        return null
    }

    return (
        <a
            href={icp.url}
            rel="noreferrer"
            target='_blank'
            {...props}
        >
            {icp.number}
        </a>
    )
}
